import FormAnalisaBarangJadi from './FormAnalisaBarangJadi';

export default FormAnalisaBarangJadi;
